import { trackEventServerSide } from "helpers/api";
import {
  MixpanelActionSource,
  MixpanelEvent,
  ToggleDeepSearchStepDrawerEvent,
  ToggleType,
} from "helpers/services/mixpanel/events";

export function useThreadInteractionStepInfoBarEvents() {
  const trackDeepSearchStepDrawerToggle = (
    interactionId: string,
    type: ToggleType
  ) => {
    const eventData: ToggleDeepSearchStepDrawerEvent = {
      event: MixpanelEvent.ToggleDeepSearchStepDrawer,
      actionSource: MixpanelActionSource.SearchStepInfoBar,
      threadInteractionId: interactionId,
      type,
    };

    trackEventServerSide(eventData);
  };

  return {
    trackDeepSearchStepDrawerToggle,
  };
}
